import React from "react";
import { Helmet } from "react-helmet";

export function ExternalDiagnosisFormHelmet({ favicon }) {
  return (
    <Helmet>
      <title>Formulário Tributário</title>
      <meta
        name="description"
        content="Cadastro interno de informações tributárias."
      />
      <meta property="og:title" content="Formulário Tributário" />
      <meta
        property="og:description"
        content="Cadastro interno de informações tributárias."
      />
      <link rel="icon" type="image/png" sizes="32x32" href={favicon} />
    </Helmet>
  );
}
